function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from "angular";
import { $uniUP } from "../..";
var SidebarController = /*#__PURE__*/function () {
  function SidebarController(sidebarScope) {
    _classCallCheck(this, SidebarController);
    this.sidebarScope = sidebarScope;
  }
  return _createClass(SidebarController, [{
    key: "visible",
    get: function get() {
      return this.sidebarScope.visible;
    }
  }, {
    key: "open",
    value: function open() {
      this.sidebarScope.visible = true;
    }
  }, {
    key: "close",
    value: function close() {
      this.sidebarScope.visible = false;
      this.sidebarScope.visibleInternal = false;
    }
  }, {
    key: "toggle",
    value: function toggle() {
      this.sidebarScope.visible = !this.sidebarScope.visible;
      this.sidebarScope.visibleInternal = this.sidebarScope.visible;
    }
  }]);
}();
$uniUP.directive("sidebarPanel", ["$timeout", "$log", "UniConfig", function ($timeout, $log, UniConfig) {
  return {
    // new SidebarForm($timeout, $log, UniConfig)
    restrict: "E",
    transclude: true,
    scope: {
      key: "@",
      idpanel: "@",
      visible: "=",
      title: "@",
      open: "@",
      onClose: "&"
    },
    require: ["?^^sidebarManager"],
    template: require("./sidebar-panel.inline.html"),
    link: function link(scope, element, attrs, ctrls) {
      $log.debug("Instanciando sidebarpanel", scope, ctrls);

      //registrar en sidebar manager si hay key y si se encuentra el sidebar manager
      if (scope.key) {
        var sidebar = new SidebarController(scope);
        if (ctrls && ctrls[0]) {
          ctrls[0].registraSidebar(scope.key, sidebar);
        } else {
          console.warn("No está registrado el sidebar manager para registrar sidebar con key ", scope.key);
        }
      }
      scope.$watch(function () {
        return scope.visible;
      }, function (val) {
        if (val) {
          angular.element("html").addClass("opened");
          $log.info("Sidebar abierto");
          $timeout(function () {
            scope.visibleInternal = true;
            element.find(".sidebarform-visible").addClass("in show");
          }, 300);
        } else $timeout(function () {
          angular.element("html").removeClass("opened");
          $log.info("Sidebar cerrado");
          scope.visibleInternal = false;
          element.find(".sidebarform-visible").removeClass("in show");

          // informar que se ha cerrado
          scope.onClose();
        }, 40);
      });
    }
  };
}]);

/** orig unitec 20190506

class SidebarForm implements ng.IDirective<ISidebarScope> {
    restrict: "E"
    transclude: boolean
    scope: {
      key: "@"
      idpanel: "@"
      visible: "="
      title: "@"
      open: "@"
      onClose: "&"
    }
    require = ["^^sidebarManager"]

    sidebarScope: ISidebarScope

    constructor(
      private $timeout: ng.ITimeoutService,
      private $log: ng.ILogService,
      private UniConfig: up.IUniConfig
    ) {
      this.restrict = "E"

      this.scope = {
        key: "@",
        idpanel: "@",
        visible: "=",
        title: "@",
        open: "@",
        onClose: "&",
      }

      // controllerAs : 'gestionCtrl',
      // templateUrl : baseUrl + '/app/templates/vigilancia/progTrabajadoresModal.html',
      this.transclude = true
      //        templateUrl : UniConfig =>
    }

    templateUrl() {
      return this.UniConfig.baseUrl + "/templates/0unitecapp/partials/utec-sidebar-panel.html"
    }

    link(scope: ISidebarScope, element, attrs, ctrls: [SidebarManagerController]) {
      this.$log.debug("Instanciando sidebarpanel", scope, ctrls)

      this.sidebarScope = scope

      //registrar en sidebar manager
      if (scope.key) {
        let sidebar = new SidebarController(scope)

        ctrls[0].registraSidebar(scope.key, sidebar)
      }

      scope.$watch(
        () => {
          return scope.visible
        },
        val => {
          if (val) {
            angular.element("html").addClass("opened")

            this.$log.info("Sidebar abierto")

            this.$timeout(() => {
              scope.visibleInternal = true
            }, 400)
          } else
            this.$timeout(() => {
              angular.element("html").removeClass("opened")

              this.$log.info("Sidebar cerrado")

              scope.visibleInternal = false

              // informar que se ha cerrado
              scope.onClose()
            }, 40)
        }
      )
    }
  }

*/